import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape, ugcCommentShape } from '@bibliocommons/bc-prop-types';
import TextUGCEditor from '../TextUGCEditor';

const CHARACTER_LIMIT = 4000;

export class CommentUGCEditor extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleTextChange', 'handleSave');

    this.state = {
      comment: ''
    };
  }

  componentWillMount() {
    const { existingComment } = this.props;
    if (existingComment && existingComment.get('comment')) {
      this.setState({
        comment: existingComment.get('comment')
      });
    }
  }

  handleTextChange(value) {
    this.setState({ comment: value });
  }

  handleSave(callback) {
    const { bib, existingComment, commentsActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const commentId = existingComment && existingComment.get('id');
    const comment = this.state.comment;
    const postSuccess = callback;

    if (commentId) {
      commentsActions.updateComment({
        comment,
        metadataId,
        commentId,
        postSuccess
      });
    } else {
      commentsActions.addComment({
        comment,
        metadataId,
        postSuccess
      });
    }
  }

  render() {
    const { bib, existingComment, commentsTransactions, shelfItem, shelfActions, shelfTransactions, handleClose, intl } = this.props;

    const commentId = existingComment && existingComment.get('id');
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const renderHeader = () => (<h2>{commentId ? <FormattedMessage id="my_comment" /> : <FormattedMessage id="add_comment" />}</h2>);
    const isSavingComment = commentId ? commentsTransactions.getIn([metadataId, commentId, 'isUpdating'], false) : commentsTransactions.getIn([metadataId, 'isAdding'], false);
    const placeholder = intl.formatMessage({ id: 'comment_placeholder' });
    const textAreaLabel = <FormattedMessage id="comment" />;

    return (
      <TextUGCEditor
        bib={bib}
        characterLimit={CHARACTER_LIMIT}
        className="cp-comment-ugc-editor"
        errorKey="comment"
        renderHeader={renderHeader}
        handleClose={handleClose}
        handleSave={this.handleSave}
        handleTextChange={this.handleTextChange}
        placeholder={placeholder}
        isSaving={isSavingComment}
        showPrivacyAlert
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
        textAreaLabel={textAreaLabel}
        text={this.state.comment} />
    );
  }
}

CommentUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingComment: ugcCommentShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default injectIntl(CommentUGCEditor);



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/CommentUGCEditor/CommentUGCEditor.jsx